import styled from 'styled-components'
import { Box } from 'app-components/common'
import { FlexContainer } from 'base-components'

export const StatsBox = styled(Box)`
  min-height: 150px;
  margin-top: 0;
  margin-bottom: 0;
  padding: 10px;
`

export const StatsBoxContainer = styled(FlexContainer)`
  background: white;
  height: 100%;
  height: fit-content;
  min-height: 295px;
  padding: 18px;
  border-radius: 3px;
`
